import { Satisfaction } from 'lib-shared-legacy-types';

import { FormValues } from '../EmailPage/components/EmailCSATSettingsForm/EmailCSATSettingsForm';

export function formatEmailCustomisationFormValuesForApi({
  delay,
  senderEmail,
  replyToEmail,
}: FormValues): Partial<Satisfaction.EmailRatingCustomization> {
  return {
    delay: Number(delay) || undefined,
    sender_email: senderEmail || null,
    reply_to_email: replyToEmail || null,
  };
}
